import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return props.boardContext.id
}

export default createSelector(
  [
    getBoardId,
    (state, props) => state.kanbo.cardRelations.byId[props.cardId] && state.kanbo.cardRelations.byId[props.cardId].childIds
  ],
  (
    boardId,
    childIds,
  ) => ({
    boardId,
    childIds,
  })
)
